require('./loansAndMortagesLegalFooter.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

//@core
const { FormattedText } = require('core/i18n').i18n;
//@constants

const LOANS_MORTGAGES_LEGAL_FOOTER = require('../../../loansConstants/loansAndMortagesLegalFooter');

class LoansAndMortagesLegalFooter extends React.Component {
    constructor(props) {
        super(props);
        this.buildProductFooter = this.buildProductFooter.bind(this);
        this.buildProductFooterPersonalLoan = this.buildProductFooterPersonalLoan.bind(this);
        this.buildProductFooterPreGrantedCredit = this.buildProductFooterPreGrantedCredit.bind(this);
        this.buildProductGeneric = this.buildProductGeneric.bind(this);
    }

    buildProductGeneric(text, isEnabled = true) {
        return (
            isEnabled && (
                <p>
                    <FormattedText value={text} />
                </p>
            )
        )
    }

    buildProductFooterPersonalLoan({ featureFlag, poEditorKeys }) {
        const { immFlagBasedFeatures } = this.props;
        const isEnabled = immFlagBasedFeatures.get(featureFlag);
        const thirdTermText = poEditorKeys[0]
        const fourTermText = poEditorKeys[1]

        const thirdTerm = this.buildProductGeneric(thirdTermText, isEnabled);
        const fourtTerm = this.buildProductGeneric(fourTermText, isEnabled);


        return (
            <React.Fragment>
                {thirdTerm}
                {fourtTerm}
            </React.Fragment>
        )
    }

    buildProductFooterPreGrantedCredit({ featureFlag, poEditorKey }) {
        const { immFlagBasedFeatures } = this.props;
        const isEnabled = immFlagBasedFeatures.get(featureFlag);
        const text = poEditorKey;
        const term = this.buildProductGeneric(text, isEnabled)

        return term
    }

    buildProductFooterMortgage({ featureFlag, poEditorKeys }) {
        const { immFlagBasedFeatures } = this.props;
        const isEnabled = immFlagBasedFeatures.get(featureFlag);
        const firstTermText = poEditorKeys[0];
        const secondTermText = poEditorKeys[1];

        const firstTerm = this.buildProductGeneric(firstTermText, isEnabled);
        const secondTerm = this.buildProductGeneric(secondTermText, isEnabled);

        return (
            <React.Fragment>
                {firstTerm}
                {secondTerm}
            </React.Fragment>
        )
    }

    buildProductFooterEasyLoan({ featureFlag, poEditorKey }) {
        const { immFlagBasedFeatures, immContractEasyLoan } = this.props;
        const isEnabled = immFlagBasedFeatures.get(featureFlag);
        let erPagoAniversario = immContractEasyLoan.get("aniversaryStandard");
        erPagoAniversario = erPagoAniversario ? erPagoAniversario.replace(new RegExp("0", 'g'), "") : "";
        let prefixEditorKey = ["26", "18", "6"].includes(erPagoAniversario) ? erPagoAniversario : ""

        const addFooter = immContractEasyLoan.get('stepReady');

        if (addFooter) {
            const tae = immContractEasyLoan.get("minTae");
            const text = (poEditorKey + prefixEditorKey).replace("[TAE]", tae);
            const term = this.buildProductGeneric(text, isEnabled);
            return term;
        }

        return;
    }

    buildProductFooter(orderedProductLegalsFooter) {
        let banners = orderedProductLegalsFooter.map((banner) => {
            let footerLegal;
            switch (banner.id) {
                case 'personalLoan':
                    footerLegal = this.buildProductFooterPersonalLoan(banner);
                    break;
                case 'easyLoan':
                    footerLegal = this.buildProductFooterEasyLoan(banner);
                    break;
                case 'pregrantedCredit':
                    footerLegal = this.buildProductFooterPreGrantedCredit(banner);
                    break;
                case 'mortgage':
                    footerLegal = this.buildProductFooterMortgage(banner);
                    break;
                default:
                    footerLegal = null;
                    break;
            }

            return footerLegal;
        });

        return banners;
    }


    render() {

        const legalFooter = this.buildProductFooter(LOANS_MORTGAGES_LEGAL_FOOTER);

        return (
            <section className="loans-legal-footer">
                {legalFooter}
            </section>
        );
    }
}

LoansAndMortagesLegalFooter.propTypes = {
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immLoans: PropTypes.object.isRequired,
    immContractEasyLoan: PropTypes.object.isRequired
};

module.exports = LoansAndMortagesLegalFooter;
